/**
 * Playlist Analytics slice
 */

import { createAction, createSlice } from '@reduxjs/toolkit';

export interface PlaylistAnalytics {
  totalPlaylists: number;
  todayPlaylists: number;
  weekPlaylists: number;
  monthPlaylists: number;
  publicPlaylists: number;
  privatePlaylists: number;
  averageItemsPerPlaylist: number;
  totalItems: number;
  topTags: Array<{ tag: string; count: number }>;
}

const initialState = {
  playlistAnalytics: null as PlaylistAnalytics | null,
  loading: false,
  error: null as string | null,
};

const playlistAnalyticsSlice = createSlice({
  name: 'playlistAnalytics',
  initialState,
  reducers: {
    setPlaylistAnalytics(state, action) {
      state.playlistAnalytics = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

// Reducer
export const playlistAnalyticsReducer = playlistAnalyticsSlice.reducer;

// Actions
export const {
  setPlaylistAnalytics,
  setLoading,
  setError,
  clearError,
} = playlistAnalyticsSlice.actions;

// Async Actions
export const fetchPlaylistAnalytics = createAction('PLAYLIST_ANALYTICS/FETCH_ANALYTICS');

